/**
 * Action Dependencies
 */
import { fetchProjects } from '../../../services/ProjectService'
import {
    fetchData,
    updateStage
} from '../../../services/DealPipelineService'

/**
 * Fetch pipeline data
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const fetchDealPipeline = ({ commit }) => {
    commit('GET_PIPELINE_DATA')
    fetchData()
        .then(res => commit('PIPELINE_GET_SUCCESS', res.data))
        .catch(err => commit('PIPELINE_GET_FAILURE', err))
}

/**
 * Update the project's stage and move the project
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updateProjectStage = ({ commit, state }, payload) => {
    let pipelineIds = state.data.map(list => list.id)
    let fromIndex = pipelineIds.indexOf(payload.from)
    let toIndex = pipelineIds.indexOf(payload.to)
    let item = state.data[fromIndex].projects.find(project => project.id === payload.item)

    commit('REMOVE_PROJECT', {
        from: fromIndex,
        item: item
    })
    commit('ADD_PROJECT', {
        to: toIndex,
        item: item,
        newPosition: payload.newPosition
    })
    updateStage(payload.item, payload.to)
}

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Get a project list scoped by stage
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const getProjectsByStage = ({ commit }, stage) => {
    return fetchProjects({ stage: stage })
        .then(res => commit('GET_STAGE_DATA_SUCCESS', res.data))
        .catch(err => console.log(err))
}

const updatePipelineList = ({ commit }, payload) => commit('UPDATE_LIST', payload)

export default {
    resetState,
    fetchDealPipeline,
    updateProjectStage,
    getProjectsByStage,
    updatePipelineList
}



// WEBPACK FOOTER //
// ./src/state/modules/deal-pipeline/actions.js